import { useState } from 'react';
import { getAttributes } from '../services/Api';

export const useAttributes = () => {
  const [attributes, setAttributes] = useState([]);
  const [mandatoryAttributes, setMandatoryAttributes] = useState([]);
  const [optionalAttributes, setOptionalAttributes] = useState([]);
  const [skuAttributes, setSkuAttributes] = useState([]);
  const [attributeValues, setAttributeValues] = useState({});
  const [loadingAttributes, setLoadingAttributes] = useState(false);
  const [fieldsToHide, setFieldsToHide] = useState(new Set());

  const fetchAttributes = async (categoryId) => {
    if (!categoryId || categoryId === 'no-category') {
      setAttributes([]);
      setMandatoryAttributes([]);
      setOptionalAttributes([]);
      setSkuAttributes([]);
      setAttributeValues({});
      setFieldsToHide(new Set());
      return;
    }

    setLoadingAttributes(true);
    try {
      const response = await getAttributes(categoryId);
      let attributesData = response.data?.data || [];
      attributesData = attributesData.filter(
        attr => attr.name !== '__images__' && attr.name !== 'name' && attr.name !== 'description'
      ); console.log(attributesData, 'ddddd');


      // Define SKU-related attribute names that should be excluded from regular attributes
      const skuRelatedFields = [
        'SellerSku', 'sku', 'price', 'package_weight', 'package_length',
        'package_width', 'package_height', 'quantity'
      ];

      const skuOnlyFields = [
        'description', 'color_family', 'size' // Add other fields that should only be in SKU
      ];

      // Filter out SKU-related attributes AND sku-only fields from regular attributes
      const regularAttributes = attributesData.filter(attr =>
        !skuRelatedFields.includes(attr.name) &&
        !skuOnlyFields.includes(attr.name) &&
        attr.attribute_type !== 'sku'
      );

      // SKU attributes are the ones that are SKU-related OR have attribute_type 'sku' OR are sku-only fields
      // const skuAttrs = attributesData.filter(attr =>
      //   skuRelatedFields.includes(attr.name) ||
      //   attr.attribute_type === 'sku' ||
      //   skuOnlyFields.includes(attr.name)
      // );

      // FIX: Set attributes to regularAttributes (filtered), not attributesData
      setAttributes(regularAttributes);

      // Separate regular attributes by type and mandatory status
      const mandatory = attributesData.filter(attr =>
        // attr.is_mandatory === 1
        attr.attribute_type == 'normal'

      );
      const optional = attributesData.filter(attr =>
        // attr.is_mandatory === 0
        attr.is_mandatory == 0 && attr.attribute_type != 'sku'

      );

      const skuAttrs = attributesData.filter(attr =>
        attr.attribute_type == 'sku'
      );

      console.log('Regular attributes:', regularAttributes);
      console.log('SKU attributes:', skuAttrs);

      setMandatoryAttributes(mandatory);
      setOptionalAttributes(optional);
      setSkuAttributes(skuAttrs);

      const fieldsToHideSet = new Set();
      const allAttributeNames = attributesData.map(attr => attr.name.toLowerCase());

      // const fieldMappings = {
      //   'brand': 'brand_name',
      //   'sku': 'sku',
      //   'sellersku': 'sku',
      //   'price': 'price',
      //   'weight': 'package_weight',
      //   'packageweight': 'package_weight',
      //   'length': 'package_length',
      //   'packagelength': 'package_length',
      //   'width': 'package_width',
      //   'packagewidth': 'package_width',
      //   'height': 'package_height',
      //   'packageheight': 'package_height',
      //   'description': 'description',
      //   'color_family': 'color_family'
      // };

      // allAttributeNames.forEach(attrName => {
      //   if (fieldMappings[attrName]) {
      //     fieldsToHideSet.add(fieldMappings[attrName]);
      //   }
      // });

      // setFieldsToHide(fieldsToHideSet);

      // Initialize values only for regular attributes (not SKU attributes)
      const initialValues = {};
      regularAttributes.forEach(attr => {
        initialValues[attr.name] = '';
      });

      console.log('Initial attribute values:', initialValues);
      setAttributeValues(initialValues);

    } catch (error) {
      console.error("Error fetching attributes", error);
      setAttributes([]);
      setMandatoryAttributes([]);
      setOptionalAttributes([]);
      setSkuAttributes([]);
      setAttributeValues({});
      setFieldsToHide(new Set());
    } finally {
      setLoadingAttributes(false);
    }
  };

  const updateAttributeValue = (attributeName, value) => {
    setAttributeValues(prev => ({
      ...prev,
      [attributeName]: value
    }));
  };

  const shouldHideField = (fieldName) => {
    return fieldsToHide.has(fieldName);
  };

  return {
    attributes,
    mandatoryAttributes,
    optionalAttributes,
    skuAttributes,
    attributeValues,
    setAttributeValues,
    updateAttributeValue,
    loadingAttributes,
    fieldsToHide,
    shouldHideField,
    fetchAttributes
  };
};